import { render, staticRenderFns } from "./WelcomeResidentModal.vue?vue&type=template&id=6b33d38c&scoped=true"
import script from "./WelcomeResidentModal.vue?vue&type=script&lang=ts"
export * from "./WelcomeResidentModal.vue?vue&type=script&lang=ts"
import style0 from "./WelcomeResidentModal.vue?vue&type=style&index=0&id=6b33d38c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b33d38c",
  null
  
)

export default component.exports